<template>
    <div>
      <div v-if="isLoading" class="wallet-loading">        
        <p>{{ $t('dass.loadingWallet') }}</p>
      </div>
      <dass-tabs
        v-else
        :preselectedTab="current_tab"
        menuClass="dass-tabs-wallet-menu"
        contentClass="dass-tabs-wallet-content"
        @tab-selected="handdlerTabSelected"
        ref="tabsWallet"
      >
        <dass-tab :name="$t('dass.balanceTransactions')">   
        <div class="dass-wallet-container">
          <div class="dass-wallet-container-cards">
            <h3>{{ $t('dass.balancesAvailable') }}</h3>
            <div class="cards-balance">
              <TotalBonusWithBalance :balanceAvailable="totalBalance" @showModalExchange="showModalExchange" @showModalGoShopping="showModalShopping"/>
              <CouponsQuantity :quantityValid="totalValidCoupons" @toGoCoupons="setTabCoupons()"/>
            </div>
          </div>            
          <StatementWithTransactionsCarriedOut />   
        </div>         
        </dass-tab>
        <dass-tab :name="$t('dass.coupons')">
          <CouponsTransactions />
        </dass-tab>
      </dass-tabs>
      <ModalShoppingVoucher
        :showModal="showModalVoucher"               
        @closeModal="closeModal"
        @acceptShoppingVoucher="acceptShoppingVoucher"
        @proceedToRefund="proceedToRefund"
      />
      <ModalExchangeValue 
        :showModal="showModalExchangeValue"
        @closeModal="showModalExchangeValue = false"
      />
      <ModalDefaultBrand 
        :showModal="showModalGoShopping"
        :message="getGeneralSettings?.SCO_MSG_COMPRAS"
        :labelButton="$t('dass.goToWebSite')"
        :title="$t('dass.goShopping')"
        @closeModal="showModalGoShopping = false"
        @actionButton="goToWebSite"
      />
    </div>
</template>

<script>
import StatementWithTransactionsCarriedOut from '@/components/organisms/wallet/StatementWithTransactionsCarriedOut.vue'
import CouponsQuantity from '@/components/organisms/wallet/CouponsQuantity.vue'
import TotalBonusWithBalance from '@/components/organisms/wallet/TotalBonusWithBalance.vue'
import CouponsTransactions from '@/components/organisms/wallet/CouponsTransactions'
import ModalShoppingVoucher from '@/components/molecules/ModalShoppingVoucher'
import ModalExchangeValue from './ModalExchangeValue.vue'
import ModalDefaultBrand from '@/components/molecules/ModalDefaultBrand'
import { mapActions, mapGetters } from 'vuex'
import { useIsSafari } from '@/composables/useIsSafari'
import {removeCharacters} from '../../../helpers/functions/removeCharacters'
export default {
  name: 'TabsWallet',
  components: {   
    CouponsQuantity,
    TotalBonusWithBalance,   
    StatementWithTransactionsCarriedOut,
    CouponsTransactions,
    ModalShoppingVoucher,
    ModalExchangeValue,
    ModalDefaultBrand
  },
  setup() {
    const { brandName } = useIsSafari()
            
    return {      
      brandName  
    }
  },
  data() {
    return {
      current_tab: 0,
      showModalVoucher: false,
      showModalExchangeValue: false,
      showModalGoShopping: false,
      isLoading: false
    }
  },
  computed: {
    ...mapGetters('create_protocol', ['getDataConsumer']),
    ...mapGetters('wallet', ['getTotalTransactions', 'getDiscountCoupons', 'getCouponsCampaign']),
    ...mapGetters('generalSettings', ['getGeneralSettings']),    
    totalBalance() {
      return this.getTotalTransactions[0]?.VALOR_VALE_COMPRAS_CREDITADO - this.getTotalTransactions[0]?.VALOR_VALE_COMPRAS_DEBITADO || 0
    },
    totalValidCoupons() {
      return this.getDiscountCoupons.filter(coupon => coupon.TCC_STATUS == 'Ativo').length
    },
  },
  methods: {
    ...mapActions('wallet', ['sumWalletTransactions', 'listWalletHistoric', 'listDiscountCoupons', 'loadCouponsCampaign', 'createCouponVtexModulate']),    
    ...mapActions('create_protocol', ['loadDataConsumer',]),
    ...mapActions('toasts', ['showToast']),
    ...mapActions('protocols', ['loadProtocols', 'updateProtocolData']),
    handdlerTabSelected(tab) {
    },
    goToWebSite() {    
      const link = this.brandName == 'fila' ? 'https://www.fila.com.br/' : this.brandName == 'umbro' ? 'https://www.umbro.com.br/' : this.brandName == 'newbalance' ? 'https://www.newbalance.com.br/' : ''
      window.open(link, '_blank')
      this.showModalGoShopping = false
    },
    setTabCoupons() {      
      this.$refs.tabsWallet.selectTab({name: this.$t('dass.coupons')})
      this.current_tab = 1
    },
    async loadDataTabs() {
      const { CON_ID } = this.getDataConsumer[0] || {}
      if(!CON_ID) return
      
      this.isLoading = true
      try {
        await Promise.all([        
          this.sumWalletTransactions({con_id: CON_ID}),
          this.listWalletHistoric({con_id: CON_ID }),
          this.listDiscountCoupons({con_id: CON_ID}),
          this.loadCouponsCampaign(),
          this.loadProtocols()
        ])
      } catch (error) {
        this.showToast({
          variant: 'error',
          message: error?.message || error
        })
      } finally {
        this.isLoading = false
      }
    },
    showModalExchange() {     
      this.showModalVoucher = !this.showModalVoucher
    },
    showModalShopping() {
      this.showModalGoShopping = !this.showModalGoShopping  
    },
    closeModal() {
      this.showModalVoucher = false
    }, 
    proceedToRefund() {
      this.showModalVoucher = false
      this.showModalExchangeValue = true
    },   
    async acceptShoppingVoucher(PRT_ID, MOT_ID) {
      if(this.isLoading) return
      if(!this.getDataConsumer[0]?.CON_CPF)  {
        this.isLoading = false
        return this.$ShowAlert({
          variant: 'warning',
          message: this.$t('dass.errorRegisterCpf')
        }) 
      }
      this.showModalVoucher = false 
      this.isLoading = true
      const response = await this.createCouponVtexModulate({
        con_id: this.getDataConsumer[0]?.CON_ID,
        cli_email: this.getDataConsumer[0]?.CON_EMAIL,
        cpf: this.getDataConsumer[0]?.CON_CPF,
        quant: 1,
        tic_codigo: this.getGeneralSettings?.TIC_CODIGO,
        prt_id: PRT_ID,
        mot_id: MOT_ID
      }).catch((error) => {
        this.isLoading = false
      })      
      if(!response?.message) {
        this.showToast({
          variant: 'error',
          message: this.$t('dass.errorProcessAcceptCoupons') + ' ' + response
        })
      } else {
        this.showToast({
          variant: 'success',
          message: this.$t('dass.generatedCouponSuccessfully') + '\n' + removeCharacters(response.message)
        })
      }
           
      await Promise.all([
        this.loadProtocols(),
        this.listDiscountCoupons({con_id: this.getDataConsumer[0]?.CON_ID}),
      ]).catch((error) => {
        this.isLoading = false
      })
      this.isLoading = false  
      setTimeout(() => this.setTabCoupons(), 1000)
    }
    
  },
  async created() {
    if (!this.getDataConsumer?.length) await this.loadDataConsumer()
    this.loadDataTabs()    
  }
}

</script>

<style lang="scss">
.dass-tabs-wallet-content {  
  padding: 2% 1%;
  height: 100%;
  width: 100%;
  min-height: 60%;
  max-height: calc(100vh - 25vh);
  overflow-y: hidden;   
  border-bottom-right-radius: var(--border-radius-card-wallet);
  border-bottom-left-radius: var(--border-radius-card-wallet);
  > div {
    height: 100%;
    width: 100%;   
    overflow-y: auto;  
  }
  .dass-wallet-container {
    display: flex;
    flex-direction: column;
    row-gap: var(--space);
    height: 100%;
    width: 100%;
  }
  .dass-wallet-container-cards {    
    display: flex; 
    flex-direction: column;
    gap: var(--space);
    padding: 1rem 0.1rem;  
    > h3 {
      margin: 0;
    }
    .cards-balance {
      display: flex;
      flex-direction: row;
      gap: var(--space);
      
      @media(max-width: 570px) {
        flex-direction: column;
      }
    }  
  }
  
}
  .dass-tabs {  
    height: 30%;
    width: 100%;      
    gap: 0 !important;    
     --tab-border-color: transparent !important;     
    @media (max-width: 430px) {
      background-color: var(--color-neutral__00) !important;      
    }
    > div {            
      box-shadow: var(--shadow-md) var(--color-primary) !important;
    }
  } 
  .dass-wallet-container-cards {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    gap: var(--space);
  }
  .dass-tabs-wallet-menu  { 
    display: flex;
    max-width: max-content; 
      
    @media (max-width: 430px) {
      flex-direction: column;
      max-width: 100%;
      width: 100%;
    }
  }  
  .dass-tab--menu-item {  
    color: var(--color-default-new-balance) !important;  
    background-color: transparent !important;     
    transition: border 0.3s ease !important;       
    text-transform: uppercase;
    &:hover {
      font-weight: bold !important;
    }
  }
  .dass-tab--menu-item:focus {
    outline: none !important;
  }
  .dass-tab--menu-item__active {  
    color: var(--theme-black) !important;
    border-bottom: 4px solid var(--theme-black) !important;
    font: normal 300 18px/26px Inter !important;
    font-weight: bold !important;
  }
  .dass-tab-name {
    text-transform: uppercase;
  }
  @media(max-width: 430px) { 
    .dass-tab--menu-item__active {
      transition: order 2.5s ease !important;           
      order: 1;
      order: 2;     
    }
  }
  
.wallet-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--space__3x);
  min-height: 400px;
  
  p {
    margin-top: var(--space);
    color: var(--theme-gray);
    font-size: 16px;    
    text-transform: capitalize !important;
  }
}    
</style>